<button
  mat-menu-item
  (click)="triggerDocumentProcessing()"
>
  <procure-ai-badge />
  Trigger document processing
</button>
